import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-light2 shadow-sm rounded" }



interface Props {
  width: number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    width: null
  },
  setup(__props: any) {

const props = __props as {
  width: number;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "h-2 bg-white rounded-l overflow-hidden",
      style: _normalizeStyle({ width: props.width + '%' })
    }, null, 4)
  ]))
}
}

})